import React from 'react';

export default (_props) => {
  const { className, size, large, small, ...props } = _props;

  // small icon
  if ((size && size.toLowerCase() === 'small') || small) {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"  className={`audiicon audiicon-small ${className ? className : ''}`} {...props}>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.3499 21.0003L11.5001 1.4707L0.650391 21.0003H22.3499ZM11 8.00024V14.0002H12V8.00024H11ZM11 16.0002V18.0002H12V16.0002H11Z" fill="#EB0D3F" />
      </svg>
    );
  }

  // large icon
  return (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={`audiicon audiicon-large ${className ? className : ''}`} {...props}>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M22.3499 21.0003L11.5001 1.4707L0.650391 21.0003H22.3499ZM11 8.00024V14.0002H12V8.00024H11ZM11 16.0002V18.0002H12V16.0002H11Z" fill="#EB0D3F" />
    </svg>
  );
};



